import { EventType } from "@/analytics/analytics-events";
import { changeMode } from "@/store/mode-slice";
import { setActiveElement } from "@/store/selections-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import { selectIElement } from "@faro-lotv/app-component-toolbox";
import { FaroMenuItem, ToolIcon } from "@faro-lotv/flat-ui";
import { Analytics } from "@faro-lotv/foreign-observers";
import { GUID } from "@faro-lotv/foundation";
import { JSX, useCallback } from "react";
import { ContextMenuAction, ContextMenuActionType } from "../action-types";

type AdjustTrajectoryActionProps = {
  /** Id of the element to adjust the trajectory for */
  elementId: GUID;

  /** Whether the action should be rendered in a dark theme. */
  dark?: boolean;
};

/**
 * @returns A context menu action for adjusting the trajectory of a video walk data session
 */
export function AdjustTrajectoryAction({
  elementId,
  dark,
}: AdjustTrajectoryActionProps): JSX.Element {
  const odometryPath = useAppSelector(selectIElement(elementId));
  const dispatch = useAppDispatch();

  const onClick = useCallback(() => {
    if (!odometryPath) return Promise.resolve();

    Analytics.track(EventType.startVideoModeEditor);

    dispatch(setActiveElement(odometryPath.id));
    dispatch(changeMode("pathAlignment"));
    return Promise.resolve();
  }, [odometryPath, dispatch]);

  return (
    <FaroMenuItem
      label="Adjust Trajectory"
      aria-label="Adjust Trajectory"
      Icon={ToolIcon}
      onClick={onClick}
      dark={dark}
    />
  );
}

export const ADJUST_TRAJECTORY_ACTION: ContextMenuAction = {
  type: ContextMenuActionType.adjustTrajectory,
  CustomComponent: AdjustTrajectoryAction,
};
